var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.dataItem["inEdit"]
    ? _c("td", [
        _vm.editOperations.edit
          ? _c("span", [
              _vm.dataItem["ReadOnlyM"] < 1 ||
              _vm.dataItem["ReadOnlyM"] === undefined
                ? _c(
                    "button",
                    {
                      staticClass: "k-primary k-button k-grid-edit-command",
                      on: { click: _vm.editHandler },
                    },
                    [_vm._v("\n            Edit\n        ")]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.editOperations.edit
          ? _c(
              "button",
              {
                staticClass: "k-button k-grid-remove-command",
                on: { click: _vm.printHandler },
              },
              [_vm._v("\n        Print\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.editOperations.remove
          ? _c(
              "button",
              {
                staticClass: "k-button k-grid-remove-command",
                on: { click: _vm.removeHandler },
              },
              [_vm._v("\n        Remove\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.editOperations.remove
          ? _c("div", { attrs: { id: "printable-content" } }, [
              _c("h1", [_vm._v("Hello bro")]),
            ])
          : _vm._e(),
      ])
    : _c("td", [
        _c(
          "button",
          {
            staticClass: "k-button k-grid-save-command",
            on: { click: _vm.addUpdateHandler },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(this.dataItem[_vm.idField] ? "Update" : "Add") +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "k-button k-grid-cancel-command",
            on: { click: _vm.cancelDiscardHandler },
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(this.dataItem[_vm.idField] ? "Cancel" : "Discard") +
                "\n    "
            ),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }